var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid-wrapper"},[_c('QuotationData'),_c('OVReceipts'),_c('OVSpareParts'),_c('OVActionHistory')],1)}
var staticRenderFns = []

export { render, staticRenderFns }